function riftUpdateCartBubble(count) {
  var wrapper = document.querySelector('.cart-count-bubble');
  if (wrapper) {
    var bubble = wrapper.querySelector('span[aria-hidden]');
    if (bubble) bubble.textContent = count;
  } else {
    var cartIcon = document.getElementById('cart-icon-bubble');
    if (cartIcon) {
      var span = document.createElement('div');
      span.className = 'cart-count-bubble';
      span.innerHTML = '<span aria-hidden="true">' + count + '</span>';
      cartIcon.appendChild(span);
    }
  }
}

function riftRenderStepper(container, qty) {
  container.innerHTML =
    '<div class="rift-stepper" style="display:flex;align-items:center;gap:10px;">' +
    '<button type="button" class="rift-btn rift-btn--outline" style="padding:8px 14px;font-size:16px;" onclick="riftChangeQty(this,-1)">−</button>' +
    '<span class="rift-stepper__qty" style="min-width:1.5em;text-align:center;font-family:var(--rift-display);">' + qty + '</span>' +
    '<button type="button" class="rift-btn rift-btn--primary" style="padding:8px 14px;font-size:16px;" onclick="riftChangeQty(this,1)">+</button>' +
    '</div>';
}

function riftRenderAddButton(container) {
  container.innerHTML =
    '<button type="button" class="rift-btn rift-btn--primary" style="font-size:15px;padding:12px 22px;" onclick="riftAddToCart(this)">Tilføj til kurv</button>';
}

function riftAddToCart(btn) {
  var container = btn.closest('[data-variant-id]');
  var variantId = container.getAttribute('data-variant-id');
  if (!variantId) return;
  btn.disabled = true;
  btn.textContent = 'Tilføjer…';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(function (res) { return res.json(); })
    .then(function () { return fetch('/cart.js'); })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      riftUpdateCartBubble(cart.item_count);
      var line = cart.items.find(function (i) { return String(i.variant_id) === String(variantId); });
      var qty = line ? line.quantity : 1;
      riftRenderStepper(container, qty);
    })
    .catch(function () {
      btn.textContent = 'Fejl - prøv igen';
      btn.disabled = false;
    });
}

function riftChangeQty(btn, delta) {
  var container = btn.closest('[data-variant-id]');
  var variantId = container.getAttribute('data-variant-id');
  var qtySpan = container.querySelector('.rift-stepper__qty');
  var currentQty = parseInt(qtySpan.textContent, 10) || 0;
  var newQty = currentQty + delta;

  container.querySelectorAll('button').forEach(function (b) { b.disabled = true; });

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: newQty })
  })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      riftUpdateCartBubble(cart.item_count);
      if (newQty <= 0) {
        riftRenderAddButton(container);
      } else {
        riftRenderStepper(container, newQty);
      }
    })
    .catch(function () {
      container.querySelectorAll('button').forEach(function (b) { b.disabled = false; });
    });
}
